import React, { useMemo } from "react";
import GenericChart from "../GenericChart";
import MultiFeatureCard from "../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard";
import get from "lodash/get";
import useFetchAiAnalyticsWidgetData from "../../../hooks/useFetchAiAnalyticsWidgetData";
import { View } from "../../../../../components/Common/react-native-components";

const FeedbackSourceMix = (props) => {
    const { itemData, applied_filter_values, timeperiodLabel } = props

    const { data, isLoading } = useFetchAiAnalyticsWidgetData({
        widgetId: "ai_analytics_feedback_source",
        appliedFilterValues: applied_filter_values,
        "widget_config": {},
    })

    const excludeColumns = ["medallia_graphql_api"]
    const chartSeries = useMemo(() => {
        if (!data) return []
        return ([
            {
                name: get(itemData, 'title', ''),
                data: get(data, 'columns', []).map((item, index) => {
                    if (!excludeColumns.includes(item)) {
                        return {
                            name: item,
                            y: get(data, `metric_data[0][${index}]`, 0)
                        }
                    }
                }).filter(Boolean)
            }
        ])
    }, [data])

    return (
        <MultiFeatureCard
            loading={isLoading}
            isNoData={!get(chartSeries, "[0].data.length", 0) && !isLoading}
            title={get(itemData, 'title', '')}
            subTitle={get(itemData, 'subTitle', '') + " " + timeperiodLabel}
            style={{ childContainer: { paddingHorizontal: 40 } }}
            renderContent={() => (
                <GenericChart
                    defaultConfig={get(itemData, 'chartDefaultConfig', {})}
                    series={chartSeries}
                    tooltipValueKeysConfig={{ isheaderVisible: false }}
                />
            )
            }
        />
    )
}
export default FeedbackSourceMix